module.exports = __webpack_public_path__ + "img/symbol_4.e396e183.png";